import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
@Component({
    selector: 'app-multiselect',
    templateUrl: './multiselect.component.html',
    styleUrls: ['./multiselect.component.scss'],
    standalone: false
})
export class MultiSelectComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() { }
}
